"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Hue = void 0;
var core_decorators_1 = require("core-decorators");
var validator_1 = require("../validation/validator");
/**
 * @param image
 * @constructor
 */
var Hue = /** @class */ (function () {
    function Hue(image) {
        this.image = image;
        this.error = null;
        this.settings = {
            hue: null,
        };
    }
    /**
     * @summary hue of the image.
     * @description supports a numeric value between `-100` and `100`
     * @param {number?} hue a number between `-100` and `100`
     * @returns {*} the operation
     */
    Hue.prototype.hue = function (hue) {
        this.error = validator_1.validator.numberNotInRange('hue', hue, -100, 100);
        if (this.error) {
            return this.image;
        }
        this.settings.hue = hue === void 0 ? null : hue;
        return this.image;
    };
    /**
     * @returns {string}
     */
    Hue.prototype.serialize = function () {
        var out = '';
        if (this.settings.hue) {
            out += "hue_" + this.settings.hue;
        }
        return {
            params: out,
            error: this.error,
        };
    };
    __decorate([
        core_decorators_1.autobind
    ], Hue.prototype, "hue", null);
    return Hue;
}());
exports.Hue = Hue;
//# sourceMappingURL=hue.js.map